// extracted by mini-css-extract-plugin
export var activityContainer = "_nk-0";
export var typingIndicatorContainer = "_nk-1";
export var typingIndicatorDot = "_nk-2";
export var wave = "_nk-3";